import { EvPlugType1Icon } from './EvPlugType1Icon';

/**
 * author: Michael Irigoyen
 * id 781567F7-B41B-4CB2-BDD8-DDF3AB75CC57
 * name ev-plug-type1
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ev-plug-type1.svg
 * tags
 * - Automotive 
 */
export const EvPlugJ1772Icon = EvPlugType1Icon;
export default EvPlugJ1772Icon